
import SerializeSimplified from "@/core/misc/decorators/SerializeSimplified";

import Core                from "@/core/Core";
import OrderPosition       from "@/domains/Orders/OrderPosition";
import BaseEntity          from "@/core/misc/BaseEntity";
import Product             from "@/domains/Products/Product";
import Unit                from "@/domains/Units/Unit";
import Qty                 from "@/core/types/Qty";

abstract class AbstractDocumentPosition extends BaseEntity {

    @SerializeSimplified
    public orderPosition: OrderPosition;

    protected _qty: Qty;

    public product: Product
    public unit: Unit

  static fromServer(data: any, result?: AbstractDocumentPosition): AbstractDocumentPosition {
        if (result === undefined) {
              throw new Error('AbstractDocumentPosition.fromServer вызывается только из наследника с готовым инстансом');
        }

        super.fromServer(data, result);

        result.orderPosition = Core.utils.hydrate(data.orderPosition, OrderPosition.fromServer)!;
        result._qty = Core.utils.hydrate(data.qty, Qty.fromServer)!;
        result.product = Core.utils.hydrate(data.product, Product.fromServer)!;
        result.unit = Core.utils.hydrate(data.unit, Unit.fromServer)!;

        return result;
    }

    static fromOrderPosition(orderPosition: OrderPosition, result?: AbstractDocumentPosition): AbstractDocumentPosition {

        if (result === undefined) {
            throw new Error('AbstractDocumentPosition.fromOrderPosition вызывается только из наследника с готовым инстансом');
        }

        result.orderPosition = orderPosition;
        result.product = orderPosition.product;
        result.unit = orderPosition.unit;
        result._qty = orderPosition.shipmentStatus?.inWork ?? new Qty('0');

        return result;
    }

    get name(): string {
        return this.orderPosition.name ?? this.product.name;
    }

    get qty(): Qty {
      return this._qty;
    }

    set qty(value: Qty) {
      this._qty = value;
    }

    /**
     * Валидирует количество позиции.
     * Максимальный порог — 100% сверх остатка (availableQty удваивается).
     * Нельзя указать меньше уже отгруженного.
     */
    validatePositionQty(value: Qty, availableQty: Qty): string | null {
        // maxQty = availableQty * 2. Удвоение через сложение с самим собой —
        // Qty не множится на скаляр, а plus(Qty) есть.
        const maxQty = availableQty.plus(availableQty);

        return Core.utils.number.validateDesiredQty(
            value,
            this.orderPosition.packageVolume,
            maxQty,
            undefined,
            this.orderPosition.unit,
        );
    }
}

export default AbstractDocumentPosition;
